export default __webpack_public_path__ + "208dae303a603c16c06ea774b973b3d1.svg";